import React, { useRef, useEffect, forwardRef, useImperativeHandle } from 'react';

const JoditEditor = forwardRef(({ 
  value = '', 
  onChange, 
  placeholder = 'Start typing...',
  height = '400px'
}, ref) => {
  const editorRef = useRef(null);
  const joditRef = useRef(null);

  useImperativeHandle(ref, () => ({
    insertHTML: (html) => {
      if (joditRef.current) {
        joditRef.current.selection.focus();
        joditRef.current.selection.insertHTML(html);
      }
    },
    getValue: () => joditRef.current?.value || '',
    focus: () => joditRef.current?.selection.focus()
  }));

  useEffect(() => {
    const loadJodit = () => {
      // Load CSS
      if (!document.querySelector('#jodit-css')) {
        const css = document.createElement('link');
        css.id = 'jodit-css';
        css.rel = 'stylesheet';
        css.href = 'https://unpkg.com/jodit@3.24.5/build/jodit.min.css';
        document.head.appendChild(css);
      }

      // Load JS
      if (!window.Jodit) {
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/jodit@3.24.5/build/jodit.min.js';
        script.onload = initJodit;
        document.head.appendChild(script);
      } else {
        initJodit();
      }
    };

    const initJodit = () => {
      if (editorRef.current && window.Jodit && !joditRef.current) {
        joditRef.current = new window.Jodit(editorRef.current, {
          height: height,
          placeholder: placeholder,
          buttons: [
            'bold', 'italic', 'underline', 'strikethrough', '|',
            'font', 'fontsize', 'brush', '|',
            'ul', 'ol', '|',
            'outdent', 'indent', 'align', '|',
            'hr', 'link', 'image', 'table', '|',
            'undo', 'redo', '|',
            'print', 'preview', 'fullsize'
          ],
          uploader: {
            insertImageAsBase64URI: true
          },
          style: {
            font: '14px Arial',
            lineHeight: '1.2'
          }
        });

        // Set initial value
        if (value) {
          joditRef.current.value = value;
        }

        // Listen for changes
        joditRef.current.events.on('change', (newValue) => {
          if (onChange) {
            onChange(newValue);
          }
        });
      }
    };

    loadJodit();

    return () => {
      if (joditRef.current) {
        joditRef.current.destruct();
        joditRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (joditRef.current && value !== joditRef.current.value) {
      joditRef.current.value = value;
    }
  }, [value]);

  const handlePrint = () => {
    if (joditRef.current) {
      const printWindow = window.open('', '_blank');
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Document</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 20px; }
              @media print { body { margin: 0; } }
            </style>
          </head>
          <body>
            ${joditRef.current.value}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    }
  };

  const handleExportHTML = () => {
    if (joditRef.current) {
      const content = joditRef.current.value;
      const blob = new Blob([content], { type: 'text/html' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'document.html';
      a.click();
      URL.revokeObjectURL(url);
    }
  };

  return (
    <div>
      <style>{`
        .jodit-wysiwyg p { margin: 0; line-height: 1.2; }
        .jodit-wysiwyg { line-height: 1.2; }
      `}</style>
      <div style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
        {/* <button 
          onClick={handlePrint}
          style={{
            padding: '8px 16px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          🖨️ Print
        </button> */}
        {/* <button 
          onClick={handleExportHTML}
          style={{
            padding: '8px 16px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          📄 Export HTML
        </button> */}
      </div>
      <textarea ref={editorRef}></textarea>
    </div>
  );
});

export default JoditEditor;